import { createFileRoute } from "@tanstack/react-router";
import { InferenceList, type InferenceSearch } from "../../features/inference/inference-list";

import { parseExplorerSearch } from "../../features/inference/playground";

const SECTIONS = ["endpoints", "models"] as const;

export const Route = createFileRoute("/_authed/$org/$project/inference/")({
  validateSearch: (s: Record<string, unknown>): InferenceSearch => ({
    ...(SECTIONS.includes(s.section as never) ? { section: s.section as InferenceSearch["section"] } : {}),
    ...parseExplorerSearch(s),
  }),
  component: InferencePage,
});

function InferencePage() {
  const { org, project } = Route.useParams();
  return <InferenceList scope={{ org, project }} search={Route.useSearch()} />;
}
